import { render, staticRenderFns } from "./FeeAddStudentComponent.vue?vue&type=template&id=455bdc57&"
import script from "./FeeAddStudentComponent.vue?vue&type=script&lang=js&"
export * from "./FeeAddStudentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports